"use strict";
import ViewBase from "../view-base.view";
import UserBadgeComponent from "../../components/common/user-badge.component";
import { staticUrls } from "../../config/constants";
import 'CssFolder/photo/photo-list-item.scss';

export default function PhotoListItemView() {
  ViewBase.call(this);
  let data;
  let onClick = (photoDetailItem) => { };
  let checkedChanged=()=>{};

  let getFirstThumbnail = (photoString) => {
    if (photoString && photoString.length > 0) {
      return photoString;
    }

    return staticUrls.imageUnavailable;
  }

  let getCount = (count) => {
    return !isNaN(count) ? count : 0;
  }

  return {
    oninit: (vnode) => {
      data = vnode.attrs.data;
      if (vnode.attrs.onClick) {
        onClick = vnode.attrs.onClick;
      }
      if(vnode.attrs.checkedChanged){
        checkedChanged=vnode.attrs.checkedChanged;
      }
    },
    view: (vnode) => {
      return m('.card.photo-item.clickable',
        m('.card-body',
          m('.photo-item-sections',
            m('.photo-item-sections__left',
             
              m('input.form-check-input.flex-shrink-0[type=checkbox]', {
                checked: vnode.attrs.data.checked, //vnode.attrs.isSelected,
                onchange: (e) => {
                  vnode.attrs.data.checked=e.target.checked;
                  checkedChanged();
                  // onCheckboxChange(survey.surveyIdString, Boolean(e.target.checked))
                }
              }),
              m('.photo-item-user-info', {
                onclick: () => {
                  onClick(data);
                }
              },
                m(UserBadgeComponent, {
                  image: data.promoterPhotoString,
                  imageSize: '48px',
                }, [
                  m('.user-name', { title: data.promoterName }, data.promoterName),
                ]),
              ),
              // Main Section
              m('.photo-item-main', {
                onclick: () => {
                  onClick(data);
                }
              },
                m('.photo-item-main__info.line-clamping__multi-2',
                  { title: data.siteName },
                  m('.photo-item-main__info-title', this.getText("LT00000XXX", "Site") + ': '),
                  `[${data.siteId}] ${data.siteName}`
                ),
                m('.photo-item-main__info.line-clamping__multi-2',
                  { title: data.customerName },
                  m('.photo-item-main__info-title', this.getText("LT00000XXX", "Customer") + ': '),
                  data.customerName
                ),
                m('.photo-item-main__info.line-clamping__multi-3',
                  { title: data.location },
                  m('.photo-item-main__info-title', this.getText("LT00000XXX", "Location") + ': '),
                  data.location
                ),
              ),
              // Secondary Section
              m('.photo-item-secondary', {
                onclick: () => {
                  onClick(data);
                }
              },
                m('.photo-item-secondary__info.line-clamping__single', { title: data.pictureType }, m('.photo-item-secondary__info-title', this.getText("LT00000XXX", "Picture Type") + ': '), data.pictureType),
                m('.photo-item-secondary__info.line-clamping__single', { title: data.product }, m('.photo-item-secondary__info-title', this.getText("LT00000XXX", "Product") + ': '), data.product),
                m('.photo-item-secondary__info.line-clamping__multi-2', { title: data.description }, m('.photo-item-secondary__info-title', this.getText("LT00000XXX", "Description") + ': '), data.description),
                m('.photo-item-secondary__info.line-clamping__single', { title: data.surveyDate }, m('.photo-item-secondary__info-title', this.getText("LT00000XXX", "Date") + ': '), data.surveyDate),
              ),
            ),
            m('.photo-item-sections__right', {
              onclick: () => {
                onClick(data);
              }
            },
              // Image Section
              m('.photo-item-image',
                m('.photo-item-image__img-wrapper',
                  m('img', { src: getFirstThumbnail(data.firstPhotoString) }),
                  m('.photo-item-image__file-count', getCount(data.photoNumber)),
                ),
              )
            ),
          ),
        )
      )
    }
  }
}
